import { Clock, TriangleAlert } from 'lucide-react';
import type { Attachment, RequestCounts } from '../../api/types';
import { strings } from '../../strings';

const t = strings.networks.topology;

/**
 * The networks list's Requests column (spec 11 6.15.20, U3.1): the pending count, neutral with "not enforced" on networks
 * whose topology doesn't enforce requests, in the warning tone on enforcing ones; stale instances in the danger tone.
 */
export function RequestCountsCell({ counts }: { counts: RequestCounts | undefined }) {
  if (!counts || (counts.pending === 0 && counts.stale === 0)) return <>{strings.common.dash}</>;
  const enforcing = !!counts.enforcing;
  return (
    <span className="flex flex-col items-start gap-1">
      {counts.pending > 0 && (
        <span className={`badge ${enforcing ? 'tone-warning' : 'tone-neutral'}`}>
          <Clock aria-hidden className="size-3.5" />
          {t.requestsCount(counts.pending, enforcing)}
        </span>
      )}
      {counts.stale > 0 && enforcing && (
        <span className="badge tone-danger">
          <TriangleAlert aria-hidden className="size-3.5" />
          {strings.networks.requests.staleCount(counts.stale)}
        </span>
      )}
    </span>
  );
}

/** The Attachments tab's Requests column: approved requests in and out, "not enforced" on non-enforcing networks. */
export function AttachmentRequestsCell({
  attachment,
  enforcing,
}: {
  attachment: Attachment;
  enforcing: boolean;
}) {
  const r = attachment.requests ?? { in: 0, out: 0 };
  if (r.in === 0 && r.out === 0) return <>{strings.common.dash}</>;
  return (
    <span>
      {t.requestsInOut(r.in, r.out)}
      {!enforcing && <span className="block text-[12px] text-fg-muted">{t.notEnforced}</span>}
    </span>
  );
}
